// extracted by mini-css-extract-plugin
export default {"form":"QuestionModal_form__2dKS3","tagsContainer":"QuestionModal_tagsContainer__s7DbT","button":"QuestionModal_button__C+2S1"};